/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type CartItem_item$ref = any;
export type CartItems_portfolioItems$ref = any;
export type CartItems_portfolioItems = {
    readonly edges: ReadonlyArray<{
        readonly node: {
            readonly id: string;
            readonly portfolioId: string | null;
            readonly portfolioItemId: string | null;
            readonly item: {
                readonly ecommerceTrackingParams: unknown | null;
                readonly serviceId: string | null;
                readonly " $fragmentRefs": CartItem_item$ref;
            } | null;
        } | null;
    } | null> | null;
    readonly " $refType": CartItems_portfolioItems$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "CartItems_portfolioItems",
    "type": "PortfolioItemsConnection",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "LocalArgument",
            "name": "loadPortfolioData",
            "type": "Boolean!",
            "defaultValue": true
        }
    ],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "PortfolioItemsEdge",
            "plural": true,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PortfolioItemV2",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "id",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "portfolioId",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "portfolioItemId",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "item",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Item",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "ecommerceTrackingParams",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "serviceId",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "CartItem_item",
                                    "args": null
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ]
} as any);
(node as any).hash = 'f44b6728a9a2bbdc68c47c53e54fbf63';
export default node;
